import { Link as LinkLi } from '@material-ui/core';
import { pageUrls } from 'globalconfig/constants/keys';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import React, { lazy } from 'react';
import { Link } from 'react-router-dom';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Search = lazy(() => import(`globalcomponents/UI/SimpleSearch/${layout}`));
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));
const Breadcrumb = lazy(() => import(`globalcomponents/Breadcrumb`));

const TopActions = ({
  fleetCompanies,
  filterSuccess,
  Styled,
  i18n,
  setPagination,
  history,
  filters,
  removeData,
  setremoveData,
  viewExportOptions,
}) => {
  const selectChange = (e) => {
    filterSuccess(e);
    setPagination(true);
    setremoveData('false');
  };

  return (
    <Styled.Wrapper>
      {layout !== 'OldUi' && <Breadcrumb filters={filters} />}
      <Styled.TopWrapper alignRight={!viewExportOptions}>
        <Styled.SearchWrapper>
          <Search
            id={'clearSearch'}
            onChange={(e) => selectChange(e)}
            default={[...fleetCompanies.list]}
            fromData
            placeHolder={i18n.t('companies.searchCompanies')}
            query={'name'}
            id="searchUser"
            onRemove={removeData}
          ></Search>
        </Styled.SearchWrapper>
        <Styled.IconWrapper>
          <LinkLi component={Link} to={pageUrls.addCompanies} className="userNew">
            <Icon src={mediaUrls?.addVehicle} primary />
          </LinkLi>
        </Styled.IconWrapper>
      </Styled.TopWrapper>
    </Styled.Wrapper>
  );
};
export default TopActions;
